
import { defineComponent } from 'vue'

import { Endpoints } from '@octokit/types'

import { Params } from '@/data/types'
import idontlikeu from '@/data/idontlikeu'
import { fetchLanguages } from '@/services/github'

import Chart from '@/components/Charts/Chart.vue'
import RepoList from './RepoList.vue'

export default defineComponent({
  props: {
    params: {
      type: Object as () => Params,
      required: true,
    },
    repositories: {
      type: Array as () => Endpoints['GET /orgs/{org}/repos']['response']['data'],
      required: true,
    },
  },
  components: {
    Chart,
    RepoList,
  },
  data() {
    return {
      langs: {} as { [key: string]: number },
      repolangs: {} as { [key: string]: { [key: string]: number } },
      ignore: true,
      blocked: false,
    }
  },
  computed: {
    filteredLangs(): { [key: string]: number } {
      const plain = { ...this.langs }
      if (!this.ignore) return plain

      const ignoreSet = new Set(
        (idontlikeu || []).map((l: string) =>
          (l || '').toString().trim().toLowerCase()
        )
      )

      const out: { [key: string]: number } = {}
      for (const [lang, val] of Object.entries(plain)) {
        if (!ignoreSet.has(lang.trim().toLowerCase()) && val > 800) {
          out[lang] = val
        }
      }

      return out
    },
  },
  methods: {
    toggleIgnore() {
      if (this.blocked) return
      this.ignore = !this.ignore
    },
  },
  watch: {
    repositories: {
      immediate: true,
      async handler() {
        const { langs, repolangs } = await fetchLanguages(
          this.repositories,
          this.params,
          this.$store
        )
        this.langs = langs
        this.repolangs = repolangs
      },
    },
  },
})
